import checkIcon from './images/check.svg';
import './NormalFilter.css';

function NormalFilter({filterId, optionId, optionLabel, selected, checkboxBackgroundColor, onClick}) {

    const handleClick = () => {
        if (onClick) onClick(filterId, optionId, selected);
    };

    const checkContainerStyle = () => {
        return {
            backgroundColor: selected ? (checkboxBackgroundColor || '#005B80') : '#FFFFFF',
            border: `solid 1px ${selected ? 'transparent' : '#979797'}`
        };
    };

    return (
        <div id={optionId} className={`normal-filter ${selected ? 'selected' : ''}`} onClick={handleClick}>
            <div className='normal-filter-check-container' style={checkContainerStyle()}>
                {selected && <img className='normal-filter-check' src={`${checkIcon}`} alt='Selected'/>}
            </div>
            <p className='normal-filter-label'>{optionLabel || 'Label'}</p>
        </div>
    );
}

export default NormalFilter;